import { RootState } from "@/modules/common";

export const selectSaturdayDeliveryProduct = (state: RootState) =>
  state.basket.saturdayDeliveryProduct;
